export const enum QueryStringKeys {
  LIST_PAGE = 'page',
}

export const enum Locales {
  ENG = 'en',
  TW = 'zh-tw',
  JA = 'ja',
  CN = 'zh-cn',
  THAI = 'th',
}

export type LocaleCode = `${Locales}`

export const enum CookieKeys {
  HAS_SMART_BANNER_CLOSED = 'hasSmartBannerClosed',
}

export const DEFAULT_LOCALE = Locales.ENG

export const DEFAULT_DEBOUNCE = 500
